import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "app-dialog" }
const _hoisted_2 = { class: "app-dialog-header" }
const _hoisted_3 = { class: "app-dialog-title" }
const _hoisted_4 = { class: "app-dialog-body" }
const _hoisted_5 = {
  key: 0,
  class: "app-dialog-actions"
}

import { computed, useSlots } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppDialog',
  props: {
    modelValue: { type: Boolean },
    title: {},
    icon: { default: undefined },
    iconColor: { default: '#6b7280' },
    maxWidth: { default: 440 },
    persistent: { type: Boolean, default: false },
    closable: { type: Boolean, default: true },
    confirmText: { default: undefined },
    cancelText: { default: undefined },
    confirmDisabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "confirm", "cancel"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const slots = useSlots();

const hasActions = computed(() => !!slots.actions || !!props.confirmText || !!props.cancelText);

// Every dismissal path (X, Cancel, ESC, outside click) also emits `cancel` so
// confirm-style parents that mount the dialog with `v-if` need no extra wiring.
const dismiss = () => {
  emit('update:modelValue', false);
  emit('cancel');
};

const onDialogToggle = (value: boolean) => {
  if (!value) dismiss();
};

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": _ctx.modelValue,
    "max-width": _ctx.maxWidth,
    persistent: _ctx.persistent,
    "onUpdate:modelValue": onDialogToggle
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.icon)
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                class: _normalizeClass(["mdi header-icon", _ctx.icon]),
                style: _normalizeStyle({ color: _ctx.iconColor })
              }, null, 6))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.title), 1),
          (_ctx.closable)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "app-dialog-close",
                title: "Close",
                onClick: dismiss
              }, _cache[1] || (_cache[1] = [
                _createElementVNode("i", { class: "mdi mdi-close" }, null, -1)
              ])))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default")
        ]),
        (hasActions.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _renderSlot(_ctx.$slots, "actions", {}, () => [
                (_ctx.cancelText)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      variant: "outlined",
                      color: "secondary",
                      disabled: _ctx.loading,
                      onClick: dismiss
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.cancelText), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  : _createCommentVNode("", true),
                (_ctx.confirmText)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 1,
                      variant: "flat",
                      color: "primary",
                      loading: _ctx.loading,
                      disabled: _ctx.confirmDisabled,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('confirm')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.confirmText), 1)
                      ]),
                      _: 1
                    }, 8, ["loading", "disabled"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "footer")
      ])
    ]),
    _: 3
  }, 8, ["model-value", "max-width", "persistent"]))
}
}

})